import { useEffect } from "react";
import { useMapStore } from "..";

export default (effect: React.EffectCallback, deps?: React.DependencyList): void => {
    const mapStore = useMapStore();

    useEffect(() => {
        if (!mapStore.isStyleLoaded)
            return;

        return effect();
    }, [mapStore.isStyleLoaded, ...(Array.isArray(deps) ? deps : [])]);
}